//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Grid } from '@mui/material'
import React from 'react'

import { useOtSelector } from '@react/redux/store'
import { ExchangeRateTypeEnum } from '@shared/Enums'
import { logOT } from '@shared/loggingShared'
import { EthAddr } from '@shared/SchemaTypes'
import { PoolDynamicOverviewCTO } from '@shared/sharedTypes'
import DynamicSetCompoundingExchangeRateForm from './DynamicSetCompoundingExchangeRateForm'
import DynamicSetDynamicExchangeRateForm from './DynamicSetDynamicExchangeRateForm'
import DynamicSetLinearExchangeRateForm from './DynamicSetLinearExchangeRateForm'
import DynamicSetTermExchangeRateForm from './DynamicSetTermExchangeRateForm'

export default function DynamicSetExchangeRateForm(props: {
  poolAddr: EthAddr
  accrueMode?: boolean
}): React.ReactElement {
  const { poolAddr, accrueMode } = props
  const poolCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr] as PoolDynamicOverviewCTO)

  const exchangeRateType = poolCTO.exchangeRateType

  logOT.info('FOCUS: exchangeRateType', exchangeRateType)
  return (
    <div data-testid="REPAY_EARLY_REDEEM_FORM">
      <Grid container spacing={6}>
        <Grid item xs={12}></Grid>
      </Grid>
      <Grid container>
        {exchangeRateType === ExchangeRateTypeEnum.Dynamic && <DynamicSetDynamicExchangeRateForm poolAddr={poolAddr} />}
        {exchangeRateType === ExchangeRateTypeEnum.Linear && <DynamicSetLinearExchangeRateForm poolAddr={poolAddr} />}
        {exchangeRateType === ExchangeRateTypeEnum.Compounding && (
          <DynamicSetCompoundingExchangeRateForm poolAddr={poolAddr} accrueMode={accrueMode} />
        )}
        {exchangeRateType === ExchangeRateTypeEnum.Term && <DynamicSetTermExchangeRateForm poolAddr={poolAddr} />}
      </Grid>
    </div>
  )
}
